import DialogContent from '@mui/material/DialogContent';
import Divider from '@mui/material/Divider';
import type { UseUserCreate } from '@openx/components-administration/lib/utils/context/UserHookTypes';
import { useConfirmationDialog } from '@openx/components-core/lib/Dialog/ConfirmationDialog/useConfirmationDialog';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { CreateUserModalForm } from '../components/CreateUserModalForm';

export type UseUserCreateModalProps = {
  handleCreateUser: ReturnType<UseUserCreate>['createUser'];
  organizationId: string;
  organizationParentAccountId: string | undefined;
};

export const useUserCreateModal = ({
  handleCreateUser,
  organizationId,
  organizationParentAccountId,
}: UseUserCreateModalProps) => {
  const { t } = useTranslation();
  const { open } = useConfirmationDialog();

  return useCallback(() => {
    open({
      cancelLabel: t('Close'),
      confirmationButtonColor: 'primary',
      hideConfirm: true,
      confirmationLabel: t('Close'),
      content: (
        <>
          <DialogContent dividers sx={{ mb: 6 }}>
            <CreateUserModalForm
              handleCreateUser={handleCreateUser}
              organizationId={organizationId}
              organizationParentAccountId={organizationParentAccountId}
            />
          </DialogContent>
          <Divider />
        </>
      ),
      customContent: true,
      title: t('Add User'),
    });
  }, [handleCreateUser, open, t, organizationId, organizationParentAccountId]);
};
